import { TabItem } from '@app/infrastructure/application/model/TabItem';
import { TabButton } from './TabButton';
import { twJoin } from 'tailwind-merge';
import { useTabsContext } from '@app/app/_context/TabsContext/useTabsContext';

interface Props {
    content: TabItem[];
    variant: 'card' | 'underline';
    ariaLabel?: string;
}

export function TabsList({ content, variant, ariaLabel }: Props) {
    const { activeTabId, setActiveTabId } = useTabsContext();

    return (
        <div
            className={twJoin(
                'relative flex overflow-x-auto overflow-y-hidden',
                'before:absolute before:inset-x-0 before:bottom-0 before:border-b before:border-b-neutral-150',
                variant === 'card' && 'gap-0.5',
                variant === 'underline' && 'gap-8',
            )}
            role="tablist"
            aria-label={ariaLabel}>
            {content.map(item => (
                <TabButton
                    key={item.id}
                    id={item.id}
                    label={item.label}
                    onClick={setActiveTabId}
                    active={activeTabId === item.id}
                    variant={variant}
                />
            ))}
        </div>
    );
}
